import Icon from "../Icon";
import useMisTareas from "../../hooks/useMisTareas";
import ChipPrioridad from "../misTareas/ChipPrioridad";
import { textoVencimiento } from "../misTareas/fechas";

// «Mis tareas» en Inicio (modelo: MisProyectos): las 4 mas urgentes y el enlace a la
// pagina. Sin permiso, sin red o con la tabla sin migrar no se pinta NADA: Inicio no se
// rompe ni enseña un error por esto.
export default function MisTareasCard({ onVerTodas, card }) {
  const { datos, estado, cargar } = useMisTareas(true);
  // Sin acceso, nada. Con un fallo de red, una linea que lo dice y deja reintentar: que la tarjeta desaparezca sin
  // avisar parece que te han quitado la funcion.
  if (estado === "no-disponible") return null;
  if (estado === "error") {
    return (
      <div style={{ ...card, padding: 16 }} role="alert">
        <div style={{ fontWeight: 700, fontSize: 11, color: "var(--text2)", marginBottom: 8, textTransform: "uppercase", letterSpacing: ".07em" }}>Mis tareas</div>
        <p style={{ fontSize: 12, color: "var(--text2)" }}>No se han podido cargar tus tareas.</p>
        <button type="button" className="btn" onClick={cargar}
          style={{ marginTop: 8, minHeight: 36, padding: "0 12px", borderRadius: 8, border: "1px solid var(--border-ctl)", background: "var(--surface)",
            color: "var(--text2)", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: "var(--font)" }}>Reintentar</button>
      </div>
    );
  }

  const lista = datos ? datos.mi_dia : null;
  // «Todo al día» solo es verdad si hubo tareas y se hicieron; a quien aun no tiene ninguna se le dice de donde
  // llegaran. Y si tiene tareas pero ninguna urgente, se dice eso.
  const pendientes = datos ? Object.values(datos.grupos).reduce((s, g) => s + g.total, 0) : 0;
  const vacio = pendientes > 0 ? `Nada urgente por ahora: tienes ${pendientes} ${pendientes === 1 ? "tarea más" : "tareas más"} en Tareas.`
    : datos && datos.hechas_total > 0 ? "Todo al día: no tienes tareas pendientes."
    : "Aún no tienes tareas. Aparecerán aquí cuando te asignen una o te manden una.";
  return (
    <div style={{ ...card, padding: 16 }}>
      <div style={{ fontWeight: 700, fontSize: 11, color: "var(--text2)", marginBottom: 12,
        textTransform: "uppercase", letterSpacing: ".07em", display: "flex", alignItems: "center", gap: 6 }}>
        <Icon name="list-check" size={13} color="var(--accent)" />Mis tareas
      </div>
      {lista === null
        ? <p style={{ fontSize: 12, color: "var(--text3)", fontStyle: "italic" }}>Cargando…</p>
        : lista.length === 0
          ? <p style={{ fontSize: 12, color: "var(--text3)", fontStyle: "italic", padding: "8px 0" }}>
              {vacio}
            </p>
          : lista.slice(0, 4).map(t => {
              const v = textoVencimiento(t.fecha);
              return (
                <button key={t.id ?? `p${t.task_id}`} className="btn" onClick={onVerTodas}
                  style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left",
                    padding: "7px 0", background: "none", border: "none", borderBottom: "1px solid var(--border2)",
                    cursor: "pointer", fontFamily: "var(--font)", color: "inherit" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.titulo}</div>
                    <div style={{ fontSize: 11, color: v.tono === "venc" ? "var(--red-text)" : "var(--text3)" }}>
                      {t.proyecto?.nombre ? `${t.proyecto.nombre} · ` : ""}{v.texto}
                    </div>
                  </div>
                  <ChipPrioridad prioridad={t.prioridad} />
                </button>
              );
            })}
      {lista !== null && lista.length > 4 && (
        <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 6 }}>y {lista.length - 4} más</div>
      )}
      <button className="btn" onClick={onVerTodas}
        style={{ marginTop: 10, width: "100%", padding: "7px", border: "1px dashed var(--border)", borderRadius: 8,
          cursor: "pointer", fontSize: 11, color: "var(--accent)", background: "var(--accent-bg)", fontFamily: "var(--font)" }}>
        Ver todas mis tareas
      </button>
    </div>
  );
}
